import React from 'react';
import { Page, View, Text, Image, StyleSheet } from '@react-pdf/renderer';
import ctbLogo from '../../../assets/ctbLogoBlue.png';

interface ChecklistCoverPageProps {
  programName: string;
  orgName?: string;
  approvedDate?: string;
}

const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#ffffff',
    fontFamily: 'Helvetica',
    alignItems: 'center',
    paddingTop: 210,
    paddingHorizontal: 30,
  },
  contentArea: {
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
  },
  logo: {
    width: 240,
    height: 90,
    objectFit: 'contain',
    marginBottom: 36,
  },
  programName: {
    fontSize: 10,
    color: '#64748b',
    fontFamily: 'Helvetica',
    textAlign: 'center',
    marginBottom: 14,
    lineHeight: 1.4,
    maxWidth: '90%',
  },
  title: {
    fontSize: 28,
    color: '#111827',
    fontFamily: 'Helvetica-Bold',
    textAlign: 'center',
    marginBottom: 10,
    letterSpacing: -0.3,
  },
  date: {
    fontSize: 10,
    color: '#64748b',
    textAlign: 'center',
    fontFamily: 'Helvetica',
  },
});

const ChecklistCoverPage: React.FC<ChecklistCoverPageProps> = ({
  programName,
  orgName,
  approvedDate,
}) => {
  const displayDate = approvedDate || new Date().toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });

  const displayProgramLabel = orgName
    ? `${orgName} — ${programName}`
    : programName;

  return (
    <Page size="A4" style={styles.page}>
      <View style={styles.contentArea}>
        <Image src={ctbLogo} style={styles.logo} />

        <Text style={styles.programName}>{displayProgramLabel}</Text>

        <Text style={styles.title}>Pentest Checklist</Text>

        <Text style={styles.date}>{displayDate}</Text>
      </View>
    </Page>
  );
};

export default ChecklistCoverPage;
